import { useTranslation } from '../../../hooks/useTranslations';

// Keep complete phrases in the dictionaries so each language can order placeholders.
export const useTaskTranslation = () => {
  const context = useTranslation();
  const taskText = (key: string, values: Record<string, string | number>) =>
    context
      .translations(key)
      .replace(/\{(\w+)\}/g, (placeholder, name) =>
        values[name] === undefined ? placeholder : String(values[name])
      );
  return { ...context, taskText };
};
